import axios from 'axios'
import auth0 from 'auth0-js'
import perms from '../modules/perms'

const webAuth = new auth0.WebAuth({
    domain: 'discordapp.com/api/oauth2/',
    clientID: '576395920787111936',
    redirectUri: process.env.CALLBACK_URL,
    responseType: 'code',
    scope: 'identify guilds email guilds.members.read',
    prompt: 'none',
})

const state = {
    userInfo: null,
}

const ADMIN = 1 << 3
const MANAGE_GUILD = 1 << 5

const mutations = {
    LOGIN(state, data) {
        state.userInfo = data
    },
    REFRESH(state, data) {
        state.userInfo.guilds = data.guilds
        state.userInfo.staffGuilds = data.viewable_guilds
    },
    LOGOUT(state) {
        state.userInfo = null
    },
    FROMURL(state, url) {
        state.prevUrl = url
    },
}

const actions = {
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            delete localStorage.token
            axios.defaults.headers.common['Authorization'] = undefined
            delete axios.defaults.headers.common['Authorization']

            this._vm.$auth.logout().then(() => {
                commit('LOGOUT')
                resolve()
            })
        })
    },
    login({ commit }) {
        return new Promise((resolve, reject) => {
            let params = new URL(document.location).searchParams
            let code = params.get('code')
            console.log(code)
            axios.defaults.withCredentials = true
            this._vm.$auth
                .authenticateUser(code)
                .then(result => {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${result.token}`
                    commit('LOGIN', result)
                    resolve(result)
                })
                .catch(e => reject(e))
            /*
                if (err) {
                    console.log(err)
                }
                axios.defaults.withCredentials = true
                localStorage.token = authResult.code
                console.log(authResult)

                this._vm.$auth
                    .authenticateUser(authResult.accessToken, authResult.refreshToken, authResult.expiresIn)
                    .then(result => {
                        axios.defaults.headers.common['Authorization'] = `Bearer ${authResult.accessToken}`
                        result.token = authResult.accessToken
                        result.refreshToken = authResult.refreshToken
                        result.expiresIn = authResult.expiresIn
                        commit('LOGIN', result)
                        resolve(result)
                    })
                    .catch(err => {
                        console.log(err)
                        reject(e)
                    })
            })*/
        })
    },
    startLogin({ commit }, prevUrl = false) {
        if (prevUrl) {
            commit('FROMURL', prevUrl)
        }
        webAuth.authorize({ prompt: 'none' })
    },
}

const getters = {
    prevUrl: state => {
        return state.prevUrl
    },
    isAuthenticated: state => {
        return !!state.userInfo
    },
    getUser: state => {
        return state.userInfo
    },
    staffGuilds: state => {
        return state.userInfo.staffGuilds
    },
    hasAdminPerms: state => guild_id => {
        if (state.userInfo == null) return false
        if (state.userInfo.guilds == undefined) return false
        if (state.userInfo.guilds[guild_id] == undefined) return false
        return (
            (state.userInfo.guilds[guild_id].permissions & ADMIN) == ADMIN ||
            (state.userInfo.guilds[guild_id].permissions & MANAGE_GUILD) == MANAGE_GUILD
        )
    },
}

export default {
    state,
    mutations,
    getters,
    actions,
}



// WEBPACK FOOTER //
// ./src/stores/auth.js